import { ApolloClient } from '@apollo/client'

class ClientSideApollo {
  private apolloClient: ApolloClient<any> = null

  set apollo(apolloClient: ApolloClient<any>) {
    this.apolloClient = apolloClient
  }

  get apollo() {
    return this.apolloClient
  }

  get exists() {
    return Boolean(this.apolloClient)
  }
}

// On the client, we store the Apollo Client in the following variable.
// This prevents the client from reinitializing between page transitions.
const clientSideApollo = new ClientSideApollo()

export default clientSideApollo
